export default __webpack_public_path__ + "static/media/gatestone-folder.f984eed2.jpg";